/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-01-29 14:32:09
 */
import { Component, Prop, Vue } from 'vue-property-decorator'
import { NewsMixinManager } from './manager'
import { NewsMixinService } from './service'
@Component
export default class NewsMixin extends Vue {
  @Prop() public total!: number
  @Prop() public menuId!: string
  @Prop() public menuTitle!: string

  manager: NewsMixinManager = new NewsMixinManager(this.total, this.menuId, new NewsMixinService())
}
